import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createManifestValidationForm } from "../../utils/validationSchema";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "./Combobox";
import BranchComboboxInput from "../Reusable/Form/ComboboxInput";
import Form from "../../layouts/Form";
import TextField from "../Reusable/Form/TextInput";

const CreateRunsheet = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createManifestValidationForm),
  });
  const { handleCreate, isLoading } = props;

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 mx-4">
          <ComboboxInput
            url={APIS.VEHILCE}
            queryKey={"vehicle"}
            register={register("vehicle")}
            errors={errors?.vehicle}
            name={"vehicle"}
            label={"Vehicle Number"}
            setValue={setValue}
            placeholder={"Search vehicle"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.DRIVER}
            queryKey={"driver"}
            register={register("driver")}
            errors={errors?.driver}
            name={"driver"}
            label={"Driver"}
            setValue={setValue}
            placeholder={"Search driver"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <BranchComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("destination_branch")}
            errors={errors?.destination_branch}
            name={"destination_branch"}
            label={"Branch"}
            setValue={setValue}
            placeholder={"Search branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <div className="mx-4">
          <TextField
            label={"Note"}
            register={register(`note`)}
            errors={errors?.note}
          />
        </div>
      </Form>
    </>
  );
};

export default CreateRunsheet;